import { Button, Modal, Stack, TextInput } from '@mantine/core';
import React, { useState } from 'react'
import showNotification from '../../../utils/showNotification';
import axios from 'axios'
import { Link, useLocation } from 'react-router-dom';

const validateEmail = (email) => {
   const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
   return regex.test(email);
};

export default function CampusDemoModal({
   setIsModal,
   isModal,
   source,
}) {
   
   const [email, setEmail] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const [error, setError] = useState(null);

   const location = useLocation();
   

   async function handleSubmit() {
      if (!validateEmail(email)) {
         setError("Por favor, ingresa un correo electrónico válido.");
         showNotification({
            color: 'red',
            status: 'error',
            title: 'Operación fallida.',
            message: `Detalles: Por favor, ingresa un correo electrónico válido.`,
         })
         return;
      }

      setError(null);

      try {

         setIsLoading(true)
         const lead = await axios.post(process.env.REACT_APP_BACKEND_SERVER + "/info/createLead",
            {
               email: email,
               source: `DEMO-${source}`,
               listmonkTemplate: 22,
               interestAreas: [location.pathname],
               flow: "CAMPUS-DEMO"
            });

         if (lead.status === 201) {
            showNotification({
               color: 'green',
               status: 'success',
               title: 'Operación exitosa.',
               message: `Recibirás las instrucciones para ingresar al campus en tu casilla de correo.`,
            })
            setIsModal(false)
         } else {
            showNotification({
               color: 'red',
               status: 'error',
               title: 'Operación fallida.',
               message: `Detalles: No ha sido posible completar la operación.`,
            })
         }
      } catch (error) {
         console.log(error)
      } finally {
         setIsLoading(false)
         setEmail('')
      }
   }


   return (
      <Modal
         closeOnClickOutside={false}
         closeOnEscape={true}
         opened={isModal}
         onClose={() => { setIsModal(false); setEmail("") }}
         size='auto'
      >
         <Stack p={0} gap={0} align="center">
            {source === 'BUTTON' && <Stack pb={40} align="center" gap={0}>
               <p style={{ fontSize: "var(--fs-small)" }}>¿Ya lo has usado?</p>
               <Button color='#FF7BAC' component={Link} to='https://campus.forvet.org/' target='_blank'>
                  Ir al campus
               </Button>
            </Stack>}
            <h1 className="CourseCampusDemo__modaltitle">
               Experimenta <br />
               <span className="CourseCampusDemo__modalgradient">
                  nuestro campus
               </span>
            </h1>
            <p className="CourseCampusDemo__modaltext">
               Te enviaremos las instrucciones a tu correo electrónico
            </p>
            <div className="Catalog__form">
               <div className="Catalog__emailDiv" style={{ margin: "1rem 0 1rem 0" }}>
                  <TextInput
                     placeholder="Ingresa tu correo electrónico"
                     value={email}
                     variant="filled"
                     onChange={(e) => {
                        if (error) setError(null);
                        setEmail(e.target.value)
                     }}
                     error={error}
                     w="100%"
                     size="lg"
                  />
               </div>
               <Button loading={isLoading} color='var(--color-tertiary)' onClick={handleSubmit} disabled={error}>
                  Recibir instrucciones
               </Button>
            </div>
         </Stack>
      </Modal>
   )
}
